import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getUniformTagLabel } from '../../../../../../../util/album-folder-tags';
import DismissCircleIcon from '../../../../../../../components/icons/DismissCircleIcon';
import Button from '../../../../../../../components/global/Button';
import CustomControl from '../../../../../../../components/global/CustomControl';
import Badge from '../../../../../../../components/global/Badge';
import SportsIcon from '../../../../../../../components/icons/SportsIcon';

const propTypes = {
  albumFolderTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      uniform_enabled: PropTypes.bool,
      uniform_numbered: PropTypes.bool,
    }),
  ).isRequired,
  identityAlbumFolderTags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    }),
  ),
  configuringTagIds: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  onTagSelected: PropTypes.func.isRequired,
  onRemoveTag: PropTypes.func,
};

const TagSelectionVerticalScroller = ({
  albumFolderTags,
  identityAlbumFolderTags = [],
  className,
  onTagSelected,
  configuringTagIds,
  onRemoveTag,
}) => {
  const [loading, setLoading] = useState(false);
  const classes = classNames({
    'tag-selection-scroller': true,
    [className]: !!className,
  });

  const onTagDelete = async tagId => {
    setLoading(true);
    await onRemoveTag(tagId);
    setLoading(false);
  };

  return (
    <div className={classes}>
      {albumFolderTags.map(albumFolderTag => {
        const isConfigured = identityAlbumFolderTags
          .map(tag => tag?.album_folder_tag?.id)
          .includes(albumFolderTag.id);

        const configuredTag = identityAlbumFolderTags.find(
          tag => tag?.album_folder_tag?.id === albumFolderTag.id,
        );

        const isActive = configuringTagIds.includes(albumFolderTag.id);

        return (
          <Button
            className="d-flex align-items-center justify-content-between"
            key={albumFolderTag.id}
            onClick={() => onTagSelected(albumFolderTag)}
          >
            <div className="d-flex">
              <SportsIcon color="#0d84fe" size={18} className="mr-1" />
              {getUniformTagLabel(albumFolderTag)}
            </div>
            <div className="d-flex">
              {isConfigured && configuredTag && onRemoveTag && (
                <Button
                  btnStyle="reset"
                  className="mr-1"
                  onClick={event => {
                    event.stopPropagation();
                    onTagDelete(configuredTag.id);
                  }}
                  disabled={loading}
                >
                  <Badge round className="d-flex align-items-center">
                    Configured
                    <DismissCircleIcon color="#0d84fe" className="ml-1" />
                  </Badge>
                </Button>
              )}
              <CustomControl
                id={`selection-${albumFolderTag.id}`}
                label="Selected Tag"
                labelSrOnly
                type="checkbox"
                size="xl"
                checked={isActive}
                className="ml-auto mr-0"
                onClick={event => {
                  event.stopPropagation();
                }}
              />
            </div>
          </Button>
        );
      })}
    </div>
  );
};

TagSelectionVerticalScroller.propTypes = propTypes;

export default TagSelectionVerticalScroller;
